import { render } from "./ChatUserSearchField.vue?vue&type=template&id=18d619f6&ts=true"
import script from "./ChatUserSearchField.vue?vue&type=script&lang=ts"
export * from "./ChatUserSearchField.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__